import { useAppDispatch, useAppSelector } from '../store/hooks'
import { goToStep } from '../store/requestSlice'
import './RejectionResult.css'

function RejectionResult() {
  const dispatch = useAppDispatch()
  const { appName, rejectionReason } = useAppSelector((state) => state.request)

  return (
    <section className="rejection-result" data-testid="rejection-result" aria-labelledby="rejection-title">
      <div className="rejection-result__icon" aria-hidden="true">&#9888;&#65039;</div>

      <h2 className="rejection-result__title" id="rejection-title">Request Rejected</h2>

      <p className="rejection-result__message">
        Your request for &apos;{appName}&apos; cannot be processed at this time.
      </p>

      <div className="rejection-result__reason-box" data-testid="rejection-reason-box" role="alert">
        <div className="rejection-result__reason-title">Reason for Rejection</div>
        <p className="rejection-result__reason-text">
          <span className="rejection-result__reason-label">Policy Violation: </span>
          {rejectionReason}
        </p>
      </div>

      <button
        className="rejection-result__edit-btn"
        data-testid="edit-request-btn"
        onClick={() => dispatch(goToStep('describe'))}
      >
        Edit Request
      </button>
    </section>
  )
}

export default RejectionResult
